import { useState } from 'react';
import type { FormEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../features/auth/AuthContext';
import { login } from '../features/auth/authApi';

const HOME_PATH = '/';
const INSTRUCTOR_HOME_PATH = '/instructor';

function LoginPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);

    try {
      const response = await login(email, password);
      auth.login(response.token, response.role);

      const defaultPath = response.role === 'INSTRUCTOR' ? INSTRUCTOR_HOME_PATH : HOME_PATH;
      const redirectTo = (location.state as { from?: { pathname: string } } | null)?.from?.pathname
        ?? defaultPath;
      navigate(redirectTo, { replace: true });
    } catch (loginError) {
      setError(
        loginError instanceof Error ? "Courriel ou mot de passe invalide." : 'Une erreur est survenue.',
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main style={{ maxWidth: 600, margin: '4rem auto', padding: '0 1rem' }}>
      <h1>Connexion</h1>
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gap: '0.75rem' }}>
          <label>
            Courriel
            <input
              style={{ width: '100%' }}
              type="email"
              name="email"
              placeholder="nom@exemple.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>
          <label>
            Mot de passe
            <input
              style={{ width: '100%' }}
              type="password"
              name="password"
              placeholder="••••••••"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </label>
          {error ? <p role="alert">{error}</p> : null}
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Connexion en cours…' : 'Se connecter'}
          </button>
        </div>
      </form>
    </main>
  );
}

export default LoginPage;
